export const GetPersonStatus = selectedBulkActionStatus => {
  let status = ''
  let message = ''
  if (selectedBulkActionStatus === 'send to draft') {
    status = 'draft'
    message = 'sent to draft person '
    // checkedArray.map(e => Updatepersonstatus({ PK: e.PK, SK: e.SK, status: 'draft' }))
    // checkedArray.map(e => toast.success(`sent to draft person `))
  } else if (selectedBulkActionStatus === 'published') {
    status = 'published'
    message = 'Approved person '
    // console.log(checkedArray, 'checkedArraycheckedArray')
    // checkedArray.map(e => Updatepersonstatus({ PK: e.PK, SK: e.SK, status: 'published' }))
    // checkedArray.map(e => toast.success(`Approved person `))
  } else if (selectedBulkActionStatus === 'Delete') {
    status = 'deleted'
    message = 'deleted person '
    // checkedArray.map(e => Updatepersonstatus({ PK: e.PK, SK: e.SK, status: 'deleted' }))
    // checkedArray.map(e => toast.success(`deleted person `))
  }

  return { status, message }
}
